var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_11560_30886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12.4C0 5.55167 5.55167 0 12.4 0C19.2483 0 24.8 5.55167 24.8 12.4C24.8 19.2483 19.2483 24.8 12.4 24.8C5.55167 24.8 0 19.2483 0 12.4Z",
    fill: "#F1E6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4004 0.200195C19.1381 0.200407 24.5996 5.66265 24.5996 12.4004C24.5994 19.138 19.138 24.5994 12.4004 24.5996C5.66265 24.5996 0.200407 19.1381 0.200195 12.4004C0.200195 5.66252 5.66252 0.200195 12.4004 0.200195Z",
    stroke: "#E2CDFF",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9004 16.9004V13.4004C14.9004 13.2678 14.8477 13.1406 14.7539 13.0468C14.6602 12.9531 14.533 12.9004 14.4004 12.9004H10.4004C10.2678 12.9004 10.1406 12.9531 10.0468 13.0468C9.95307 13.1406 9.90039 13.2678 9.90039 13.4004V16.9004M9.90039 7.90039V9.90039C9.90039 10.033 9.95307 10.1602 10.0468 10.2539C10.1406 10.3477 10.2678 10.4004 10.4004 10.4004H13.9004M14.0004 7.90039C14.2642 7.90415 14.5158 8.01198 14.7004 8.20039L16.6004 10.1004C16.7888 10.285 16.8966 10.5366 16.9004 10.8004V15.9004C16.9004 16.1656 16.795 16.42 16.6075 16.6075C16.42 16.795 16.1656 16.9004 15.9004 16.9004H8.90039C8.63517 16.9004 8.38082 16.795 8.19328 16.6075C8.00575 16.42 7.90039 16.1656 7.90039 15.9004V8.90039C7.90039 8.63517 8.00575 8.38082 8.19328 8.19328C8.38082 8.00575 8.63517 7.90039 8.90039 7.90039H14.0004Z",
    stroke: "#420499",
    strokeWidth: 0.933333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_11560_30886",
    x: 0,
    y: 0,
    width: 24.8008,
    height: 24.8008,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.764688 0 0 0 0 0.644257 0 0 0 0 0.93368 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11560_30886"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavedIcon);
export default __webpack_public_path__ + "static/media/saved_icon.35fea0bb87c095fdccaf95f2cb8d60fa.svg";
export { ForwardRef as ReactComponent };